import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true})

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const stampDatum = (id, userId, sessionId) => API.put(`datum/${id}/stamp`, {userId: userId, sessionId: sessionId});
export const viewDatum = (id, userId, sessionId) => API.put(`datum/${id}/view`, {userId: userId, sessionId: sessionId});
export const getDatum = (userId, state) => API.get(`datum/getDatum/${userId}/${state}`);
export const dbUpdate = (up) => API.get(`datum/dbupdate/${up}`);
export const getDatum_One = (datumid) => API.get(`datum/${datumid}`,{datumid:datumid});
// export const getItemByID = (id) => API.get(`datum/getItemById/${id}`);
export const unstamp_datum = (datumID) => API.put(`datum/unstamp_datum/${datumID}`,{datumID:datumID});
export const req_unstamp = (datum_id, user_id) => API.put(`datum/req_unstamp/${datum_id}/${user_id}`);
export const getPendingUnstampRequests = (authorId) => API.get(`datum/unstamp-requests/pending/${authorId}`);
export const getResolvedUnstampRequests = (authorId) => API.get(`datum/unstamp-requests/resolved/${authorId}`);
export const getDatumWithStampDetails = (datumId, userId) =>
    API.get(`/datum/full/${datumId}/${userId}`);
export const checkDatumStampable = (datumId, userId) =>
    API.get(`/datum/stampable/${datumId}/${userId}`);
